"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconContainer_1 = __importDefault(require("../IconContainer"));
const GoogleIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (react_1.default.createElement(IconContainer_1.default, Object.assign({ className: (0, classnames_1.default)("gerudo-icon-google", size, className) }, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "23.516", height: "24", viewBox: "0 0 23.516 24", role: "img", "aria-label": title },
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("path", { fill: "currentColor", stroke: "none", role: "presentation", d: "M12,10.281H23.328a11.359,11.359,0,0,1,.188,2,12.656,12.656,0,0,1-1.422,6.055A10.268,10.268,0,0,1,18.039,22.5,11.982,11.982,0,0,1,12,24a11.8,11.8,0,0,1-4.672-.945A11.766,11.766,0,0,1,.945,16.672a12.021,12.021,0,0,1,0-9.344A11.766,11.766,0,0,1,7.328.945,11.8,11.8,0,0,1,12,0a11.371,11.371,0,0,1,8.047,3.141l-3.266,3.14A6.607,6.607,0,0,0,12,4.422,7.163,7.163,0,0,0,8.273,5.438,7.586,7.586,0,0,0,4.562,12a7.586,7.586,0,0,0,3.711,6.562A7.163,7.163,0,0,0,12,19.578a7.965,7.965,0,0,0,2.5-.375,6.315,6.315,0,0,0,1.875-.937,6.733,6.733,0,0,0,1.281-1.282,5.958,5.958,0,0,0,.8-1.359,5.693,5.693,0,0,0,.351-1.219H12Z" }))));
};
exports.GoogleIcon = GoogleIcon;
GoogleIcon.defaultProps = {
    title: "Google icon",
};
exports.default = GoogleIcon;
//# sourceMappingURL=Google.js.map